var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyscraper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.741 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1742",
    d: "M5.389 22.5V5.389h8.963V22.5m4.889-2.444V8.648h-4.889m-8.963 0H.5v11.407M7.833 8.648h4.074m-9.778 2.444h1.63m-1.63 2.444h1.63m-1.63 2.444h1.63m-1.63 2.444h1.63m12.222-7.333h1.63m-1.63 2.444h1.63m-1.63 2.444h1.63m-1.63 2.444h1.63M7.833 11.09h4.074m-4.074 2.444h4.074m-4.074 2.444h4.074m-4.074 2.444h4.074m0-15.481H7.833v2.444h4.074zM9.87.5v2.444M11.093 22.5v-1.63H8.649v1.63",
    fill: "none",
    stroke: "#d82f89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "/_next/static/assets/public/images/accommodation-map/de0d36846a59b7276d9593d4bc8a3ab5.svg";
export { SvgSkyscraper as ReactComponent };